import { makeAutoObservable } from 'mobx';

export class RaceSummaryHorseRacingState {
    public isExpanded: boolean = true;

    public constructor() {
        makeAutoObservable(this);
    }

    public onExpand = (): void => {
        this.isExpanded = !this.isExpanded;
    };
}
